import React, { useState } from 'react';
import Navigation from '../sections/Navigation';
import Footer from '../sections/Footer';
import ContactModal from '../sections/ContactModal';
// constants import not needed here after layout changes

const AboutUsPage = () => {
  // Removed unused variables to satisfy CI lint rules
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });
  const [showCursor, setShowCursor] = useState(false);
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const handleMouseMove = (e) => {
    setCursorPosition({ x: e.clientX, y: e.clientY });
  };

  const handleMouseEnter = () => setShowCursor(true);
  const handleMouseLeave = () => setShowCursor(false);

  // Core Values data with icons
  const coreValues = [
    {
      id: 1,
      title: 'Transparency and Accountability',
      icon: 'shield',
    },
    {
      id: 2,
      title: 'Driving Innovation',
      icon: 'lightbulb',
    },
    {
      id: 3,
      title: 'Customer-Centric',
      icon: 'target',
    },
    {
      id: 4,
      title: 'Adaptability and Growth',
      icon: 'people',
    },
    {
      id: 5,
      title: 'Security Excellence',
      icon: 'security',
    },
  ];

  // Icon components
  const getIcon = (iconType) => {

    switch (iconType) {
      case 'shield':
        return (
          <svg width="100%" height="100%" viewBox="0 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
            <path d="M10 0L0 5V10C0 15.55 3.84 20.74 10 23C16.16 20.74 20 15.55 20 10V5L10 0ZM10 19.92C5.04 17.93 1.5 13.52 1.5 10V6.38L10 2.28L18.5 6.38V10C18.5 13.52 14.96 17.93 10 19.92Z" fill="#F05736" />
          </svg>
        );
      case 'lightbulb':
        return (
          <svg width="100%" height="100%" viewBox="0 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
            <path d="M10 0C4.48 0 0 4.48 0 10C0 13.86 2.34 17.21 5.68 18.68L7 19.24V23H13V19.24L14.32 18.68C17.66 17.21 20 13.86 20 10C20 4.48 15.52 0 10 0ZM12 21H8V19H12V21ZM11 16H9V14H11V16Z" fill="#F05736" />
          </svg>
        );
      case 'target':
        return (
          <svg width="100%" height="100%" viewBox="0 0 35 33" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
            <circle cx="12" cy="12" r="10" stroke="#F05736" strokeWidth="2" fill="none" />
            <circle cx="12" cy="12" r="6" stroke="#F05736" strokeWidth="2" fill="none" />
            <circle cx="12" cy="12" r="2" fill="#F05736" />
            <path d="M24 20L32 28" stroke="#F05736" strokeWidth="2" strokeLinecap="round" />
          </svg>
        );
      case 'people':
        return (
          <svg width="100%" height="100%" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
            <path d="M13 4C13 5.66 11.66 7 10 7C8.34 7 7 5.66 7 4C7 2.34 8.34 1 10 1C11.66 1 13 2.34 13 4ZM16 13C16 14.1 15.1 15 14 15H6C4.9 15 4 14.1 4 13V11C4 9.9 4.9 9 6 9H14C15.1 9 16 9.9 16 11V13Z" fill="#F05736" />
          </svg>
        );
      case 'security':
        return (
          <svg width="100%" height="100%" viewBox="0 0 26 23" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
            <path d="M13 0L0 5V10C0 16.08 4.42 21.34 10.5 22.87C11.5 22.95 12.5 23 13 23C13.5 23 14.5 22.95 15.5 22.87C21.58 21.34 26 16.08 26 10V5L13 0ZM13 19.5C8.86 19.5 5.5 16.14 5.5 12C5.5 7.86 8.86 4.5 13 4.5C17.14 4.5 20.5 7.86 20.5 12C20.5 16.14 17.14 19.5 13 19.5ZM16.75 9.75L12.25 14.25L9.25 11.25L10.32 10.18L12.25 12.11L15.68 8.68L16.75 9.75Z" fill="#F05736" />
          </svg>
        );
      default:
        return null;
    }
  };

  return (
    <div
      className="relative w-full bg-white custom-cursor-container"
      onMouseMove={handleMouseMove}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {showCursor && (
        <div className="custom-cursor hidden md:block" style={{ left: `${cursorPosition.x}px`, top: `${cursorPosition.y}px` }}>
          <div className="cursor-dot"></div>
        </div>
      )}
      {/* Hero Section */}
      <section
        className="relative w-full h-auto min-h-[500px] sm:min-h-[550px] md:min-h-[600px] lg:h-[700px] bg-cover bg-center bg-no-repeat overflow-hidden rounded-b-[20px] sm:rounded-b-[30px]"
        style={{
          backgroundImage: "url('/hero-bg.jpg')"
        }}
      >
        {/* Gradient Overlay */}
        <div
          className="absolute inset-0 opacity-25"
          style={{
            background: 'linear-gradient(270deg, rgba(102, 102, 102, 0.2) 0%, #000000 42.66%)'
          }}
        />

        {/* Content */}
        <div className="relative z-10 min-h-[500px] sm:min-h-[550px] md:min-h-[600px] lg:h-full flex flex-col pb-4">
          <Navigation />

          {/* Hero Content - Centered */}
          <div className="flex flex-col justify-center items-center flex-1 px-4 sm:px-6 md:px-12 lg:px-24 text-center">
            <h1
              className="font-medium text-[32px] sm:text-[42px] md:text-[52px] lg:text-[62px] leading-[1.2] sm:leading-[1.25] lg:leading-[75px] text-white mb-4 sm:mb-6 md:mb-8"
              style={{
                textShadow: 'none'
              }}
            >
              About Us
            </h1>

            <p
              className="font-normal text-[14px] sm:text-[18px] md:text-[20px] lg:text-[24px] leading-[1.4] sm:leading-[1.5] lg:leading-[35px] text-white max-w-[280px] sm:max-w-[500px] md:max-w-[600px] lg:max-w-[700px] mx-auto"
              style={{
                textShadow: 'none'
              }}
            >
              Reliable technology solutions built on trust, expertise, and long-term partnerships.
            </p>
          </div>
        </div>
      </section>

      {/* We Are Elowen Section */}
      <section className="w-full py-16 md:py-20 lg:py-24">
        <div className="w-full px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-20 flex justify-center">
          {/* Frame 68 - Main Container */}
          {/* Desktop Layout - Absolute Positioning */}
          <div
            className="hidden lg:block relative w-full max-w-[1101px] h-[360px] mx-auto"
            style={{
              fontFamily: 'Murecho, sans-serif'
            }}
          >
            {/* We Are - Left Column, Top */}
            <h2
              className="absolute left-[31px] top-[10px] w-[93px] h-[180px] m-0"
              style={{
                fontFamily: 'Murecho',
                fontStyle: 'normal',
                fontWeight: 400,
                fontSize: '62px',
                lineHeight: '90px',
                color: '#1A1A1A'
              }}
            >
              We Are
            </h2>

            {/* Elowen - Left Column, Bottom */}
            <div
              className="absolute left-[32px] top-[190px] w-[222px] h-[98px] m-0"
              style={{
                fontFamily: 'Murecho',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '68px',
                lineHeight: '98px',
                background: 'linear-gradient(98.02deg, #F05736 9.58%, #FBB12F 117.25%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}
            >
              Elowen
            </div>

            {/* Reliable IT Managed Services... - Right Column, Top Heading */}
            <h3
              className="absolute left-[357px] top-[10px] w-[716px] h-[82px] m-0"
              style={{
                fontFamily: 'Murecho',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '24px',
                lineHeight: '35px',
                color: '#1A1A1A'
              }}
            >
              Reliable IT Managed Services, SOC Operations, Resource Outsourcing & AI Adoption Consulting
            </h3>

            {/* Paragraph Text - Right Column, Bottom */}
            <p
              className="absolute left-[357px] top-[101px] w-[718px] h-auto m-0"
              style={{
                fontFamily: 'Murecho',
                fontStyle: 'normal',
                fontWeight: 400,
                fontSize: '24px',
                lineHeight: '35px',
                color: '#1A1A1A'
              }}
            >
              At Elowen, we offer a complete range of IT managed services, SOC operations, resource outsourcing, and AI adoption consulting, designed to help businesses streamline operations, enhance security, and integrate cutting-edge technology. Whether you're a startup or a large enterprise, our team ensures your IT infrastructure and AI initiatives run smoothly and efficiently.
            </p>
          </div>

          {/* Mobile/Tablet Layout - Flexbox */}
          <div className="lg:hidden w-full max-w-[1101px] mx-auto flex flex-col gap-6">
            {/* We Are Elowen */}
            <div className="flex flex-col text-center">
              <h2
                className="font-normal text-[42px] sm:text-[52px] leading-[50px] text-[#1A1A1A] m-0"
                style={{
                  fontFamily: 'Murecho',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  color: '#1A1A1A'
                }}
              >
                We
              </h2>
              <h2
                className="font-normal text-[42px] sm:text-[52px] leading-[50px] text-[#1A1A1A] m-0"
                style={{
                  fontFamily: 'Murecho',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  color: '#1A1A1A'
                }}
              >
                Are
              </h2>
              <div
                className="font-medium text-[52px] sm:text-[60px] leading-[98px] m-0"
                style={{
                  fontFamily: 'Murecho',
                  fontStyle: 'normal',
                  fontWeight: 500,
                  background: 'linear-gradient(98.02deg, #F05736 9.58%, #FBB12F 117.25%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text'
                }}
              >
                Elowen
              </div>
            </div>

            {/* Content */}
            <div className="flex flex-col gap-4">
              <h3
                className="font-medium text-[20px] sm:text-[22px] leading-[35px] text-[#1A1A1A] m-0"
                style={{
                  fontFamily: 'Murecho',
                  fontStyle: 'normal',
                  fontWeight: 500,
                  color: '#1A1A1A'
                }}
              >
                Reliable IT Managed Services, SOC Operations, Resource Outsourcing & AI Adoption Consulting
              </h3>
              <p
                className="font-normal text-[18px] sm:text-[20px] leading-[35px] text-[#1A1A1A] m-0"
                style={{
                  fontFamily: 'Murecho',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  color: '#1A1A1A'
                }}
              >
                At Elowen, we offer a complete range of IT managed services, SOC operations, resource outsourcing, and AI adoption consulting, designed to help businesses streamline operations, enhance security, and integrate cutting-edge technology. Whether you're a startup or a large enterprise, our team ensures your IT infrastructure and AI initiatives run smoothly and efficiently.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values Section */}
      <section className="w-full py-16 md:py-20 lg:py-24">
        {/* Frame 84 - Main Container - Desktop - Full Width, No Side Spacing */}
        <div
          className="hidden lg:block relative w-full h-[596px] rounded-[30px]"
          style={{
            background: 'linear-gradient(180deg, #194952 -21.18%, #081417 64.31%)',
            fontFamily: 'Murecho, sans-serif'
          }}
        >
          {/* Our Core Values - Title */}
          <h2
            className="absolute w-[288px] h-[58px] m-0"
            style={{
              left: 'calc(50% - 288px/2 + 1.5px)',
              top: '58px',
              fontFamily: 'Murecho',
              fontStyle: 'normal',
              fontWeight: 500,
              fontSize: '40px',
              lineHeight: '58px',
              textAlign: 'center',
              color: '#FFFFFF',
              textShadow: '0px 4px 4px rgba(0, 0, 0, 0.02)',
              backdropFilter: 'blur(2px)'
            }}
          >
            Our Core Values
          </h2>

          {/* Description */}
          <p
            className="absolute w-[626px] h-[70px] m-0"
            style={{
              left: 'calc(50% - 626px/2 + 1.5px)',
              top: '139px',
              fontFamily: 'Murecho',
              fontStyle: 'normal',
              fontWeight: 400,
              fontSize: '24px',
              lineHeight: '35px',
              textAlign: 'center',
              color: '#FFFFFF'
            }}
          >
            Hear how businesses trust Elowen IT to deliver reliable, secure, and scalable technology solutions.
          </p>

          {/* Frame 83 - Core Values Container - Full width, no side spacing, scaled up */}
          <div
            className="absolute h-[350.25px] w-full left-0"
            style={{
              top: '188px'
            }}
          >
            {/* Inner container - full width with proportional card scaling, no padding */}
            <div
              className="relative h-full w-full"
            >
              {/* Frame 78 - Transparency and Accountability - Left, Top Row, Icon Right */}
              <div
                className="absolute h-[104.25px] rounded-[22.5px]"
                style={{
                  left: '2%',
                  width: '30%',
                  top: '84px',
                  background: '#055A6B',
                  boxShadow: '0px 3px 3px rgba(0, 0, 0, 0.02)',
                  backdropFilter: 'blur(1.5px)'
                }}
              >
                <h3
                  className="absolute h-[70px] m-0 pr-20"
                  style={{
                    left: '42px',
                    top: '17px',
                    fontFamily: 'Murecho',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    fontSize: '24px',
                    lineHeight: '35px',
                    color: '#FFFFFF'
                  }}
                >
                  {coreValues[0].title}
                </h3>
                <div
                  className="absolute w-[78px] h-[78px] bg-white rounded-full flex items-center justify-center"
                  style={{
                    right: '4px',
                    top: 'calc(50% - 78px/2 - 0.12px)'
                  }}
                >
                  <div style={{ width: '30px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {getIcon(coreValues[0].icon, 0)}
                  </div>
                </div>
              </div>

              {/* Frame 79 - Driving Innovation - Center, Top Row, Icon Right */}
              <div
                className="absolute h-[104.25px] rounded-[22.5px]"
                style={{
                  left: 'calc(50% - 30%/2)',
                  width: '30%',
                  top: '85px',
                  background: '#055A6B',
                  boxShadow: '0px 3px 3px rgba(0, 0, 0, 0.02)',
                  backdropFilter: 'blur(1.5px)'
                }}
              >
                <h3
                  className="absolute h-[35px] m-0 pr-20"
                  style={{
                    left: '43.5px',
                    top: 'calc(50% - 35px/2 + 0.38px)',
                    fontFamily: 'Murecho',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    fontSize: '24px',
                    lineHeight: '35px',
                    color: '#FFFFFF'
                  }}
                >
                  {coreValues[1].title}
                </h3>
                <div
                  className="absolute w-[78px] h-[78px] bg-white rounded-full flex items-center justify-center"
                  style={{
                    right: '4px',
                    top: 'calc(50% - 78px/2 + 0.88px)'
                  }}
                >
                  <div style={{ width: '30px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {getIcon(coreValues[1].icon, 1)}
                  </div>
                </div>
              </div>

              {/* Frame 72 - Customer-Centric - Right, Top Row, Icon Right */}
              <div
                className="absolute h-[104.25px] rounded-[22.5px]"
                style={{
                  right: '2%',
                  width: '30%',
                  top: '84px',
                  background: '#055A6B',
                  boxShadow: '0px 3px 3px rgba(0, 0, 0, 0.02)',
                  backdropFilter: 'blur(1.5px)'
                }}
              >
                <h3
                  className="absolute h-[35px] m-0 pr-20"
                  style={{
                    left: '38px',
                    top: 'calc(50% - 35px/2 + 0.38px)',
                    fontFamily: 'Murecho',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    fontSize: '24px',
                    lineHeight: '35px',
                    color: '#FFFFFF'
                  }}
                >
                  {coreValues[2].title}
                </h3>
                <div
                  className="absolute w-[78px] h-[78px] bg-white rounded-full flex items-center justify-center"
                  style={{
                    right: '4px',
                    top: 'calc(50% - 78px/2 + 0.38px)'
                  }}
                >
                  <div style={{ width: '30px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {getIcon(coreValues[2].icon, 2)}
                  </div>
                </div>
              </div>

              {/* Frame 80 - Adaptability and Growth - Left-Center, Bottom Row, Icon Left */}
              <div
                className="absolute h-[104.25px] rounded-[22.5px]"
                style={{
                  left: '18%',
                  width: '30%',
                  top: '218px',
                  background: '#055A6B',
                  boxShadow: '0px 3px 3px rgba(0, 0, 0, 0.02)',
                  backdropFilter: 'blur(1.5px)'
                }}
              >
                <div
                  className="absolute w-[78px] h-[78px] bg-white rounded-full flex items-center justify-center"
                  style={{
                    left: '15px',
                    top: 'calc(50% - 78px/2 + 0.38px)'
                  }}
                >
                  <div style={{ width: '30px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {getIcon(coreValues[3].icon, 3)}
                  </div>
                </div>
                <h3
                  className="absolute h-[35px] m-0 pl-20"
                  style={{
                    left: '93px',
                    top: 'calc(50% - 35px/2 + 0.38px)',
                    fontFamily: 'Murecho',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    fontSize: '24px',
                    lineHeight: '35px',
                    color: '#FFFFFF'
                  }}
                >
                  {coreValues[3].title}
                </h3>
              </div>

              {/* Frame 75 - Security Excellence - Right, Bottom Row, Icon Left */}
              <div
                className="absolute h-[104.25px] rounded-[22.5px]"
                style={{
                  right: '18%',
                  width: '30%',
                  top: '219px',
                  background: '#055A6B',
                  boxShadow: '0px 3px 3px rgba(0, 0, 0, 0.02)',
                  backdropFilter: 'blur(1.5px)'
                }}
              >
                <div
                  className="absolute w-[78px] h-[78px] bg-white rounded-full flex items-center justify-center"
                  style={{
                    left: '26px',
                    top: 'calc(50% - 78px/2 + 0.38px)'
                  }}
                >
                  <div style={{ width: '30px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {getIcon(coreValues[4].icon, 4)}
                  </div>
                </div>
                <h3
                  className="absolute h-[35px] m-0 pl-20"
                  style={{
                    left: '105px',
                    top: 'calc(50% - 35px/2 - 1.62px)',
                    fontFamily: 'Murecho',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    fontSize: '24px',
                    lineHeight: '35px',
                    color: '#FFFFFF'
                  }}
                >
                  {coreValues[4].title}
                </h3>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile/Tablet Layout */}
        <div
          className="lg:hidden w-full rounded-[30px] px-6 py-12"
          style={{
            background: 'linear-gradient(180deg, #194952 -21.18%, #081417 64.31%)',
            fontFamily: 'Murecho, sans-serif'
          }}
        >
          <h2
            className="font-medium text-[32px] sm:text-[36px] md:text-[40px] leading-[58px] text-white text-center mb-6"
            style={{
              textShadow: '0px 4px 4px rgba(0, 0, 0, 0.02)',
              backdropFilter: 'blur(2px)'
            }}
          >
            Our Core Values
          </h2>

          <p
            className="font-normal text-[18px] sm:text-[20px] md:text-[24px] leading-[35px] text-white text-center mb-12 max-w-[626px] mx-auto"
          >
            Hear how businesses trust Elowen IT to deliver reliable, secure, and scalable technology solutions.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {coreValues.map((value, index) => {
              const isLeftIcon = index === 3 || index === 4;
              return (
                <div
                  key={value.id}
                  className="relative p-6 rounded-[22.5px] min-h-[104px] flex items-center"
                  style={{
                    background: '#055A6B',
                    boxShadow: '0px 3px 3px rgba(0, 0, 0, 0.02)',
                    backdropFilter: 'blur(1.5px)'
                  }}
                >
                  {isLeftIcon && (
                    <div className="w-[78px] h-[78px] bg-white rounded-full flex items-center justify-center flex-shrink-0 mr-4">
                      <div style={{ width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {getIcon(value.icon, index)}
                      </div>
                    </div>
                  )}
                  <h3 className={`font-normal text-[18px] md:text-[20px] leading-[35px] text-white flex-1`}>
                    {value.title}
                  </h3>
                  {!isLeftIcon && (
                    <div className="w-[78px] h-[78px] bg-white rounded-full flex items-center justify-center flex-shrink-0 ml-4">
                      <div style={{ width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {getIcon(value.icon, index)}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

      </section>

      {/* Meet Our Leaders Section */}
      <section className="w-full py-16 md:py-20 lg:py-24">
        <div className="w-full px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-20">
          <div className="w-full max-w-6xl mx-auto flex flex-col gap-12 md:gap-20">
            <h2
              className="text-center font-medium text-[28px] sm:text-[34px] leading-[40px] sm:leading-[49px] text-[#1A1A1A] mb-4 sm:mb-8"
              style={{
                textShadow: '0px 4px 4px rgba(0, 0, 0, 0.02)',
                backdropFilter: 'blur(2px)'
              }}
            >
              Meet Our Leaders
            </h2>

            {/* Leader 1 */}
            <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12 lg:gap-20">
              {/* Image Container */}
              <div className="relative w-full max-w-[380px] aspect-[380/390] flex-shrink-0 mx-auto md:mx-0">
                {/* Gradient Frame */}
                <div
                  className="absolute inset-0 rounded-[5px] translate-x-[-6px] translate-y-[-6px]"
                  style={{
                    background: 'linear-gradient(139.65deg, #F05736 0%, #FBB12F 95.17%)',
                    zIndex: 0
                  }}
                />
                {/* Image */}
                <div
                  className="absolute inset-0 rounded-[5px] overflow-hidden bg-gray-200"
                  style={{
                    backgroundImage: "url('/leader1.png')",
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    zIndex: 1
                  }}
                />
              </div>

              {/* Text */}
              <div className="flex-1 text-center md:text-left">
                <p className="font-normal text-[16px] sm:text-[18px] md:text-[20px] leading-[1.6] md:leading-[29px] text-[#1A1A1A]">
                  <span className="font-bold">Technology leader</span> with over 13 years of experience building and scaling high-impact IT operations and digital-first businesses. Known for transforming ideas into growth engines, he has led global initiatives across IT service management—achieving profitability and cutting downtime by 30% year-on-year. He is also passionate about mentoring and handholding budding startups, helping them accelerate transformation and operational excellence.
                  <br /><br />
                  An IIM Lucknow alumnus, also holds certifications in ITIL, Six Sigma, Scrum, Data Analytics, and Project Management Essentials. Recognized for building high-performing teams and optimizing enterprise IT, he is dedicated to guiding organizations through the evolving digital and AI-driven era.
                </p>
              </div>
            </div>

            {/* Leader 2 */}
            <div className="flex flex-col md:flex-row-reverse items-center gap-8 md:gap-12 lg:gap-20">
              {/* Image Container */}
              <div className="relative w-full max-w-[380px] aspect-[380/390] flex-shrink-0 mx-auto md:mx-0">
                {/* Gradient Frame */}
                <div
                  className="absolute inset-0 rounded-[5px] translate-x-[-6px] translate-y-[-6px] md:translate-x-[6px]"
                  style={{
                    background: 'linear-gradient(223.51deg, #F05736 0%, #FBB12F 100%)',
                    zIndex: 0
                  }}
                />
                {/* Image */}
                <div
                  className="absolute inset-0 rounded-[5px] overflow-hidden bg-gray-200"
                  style={{
                    backgroundImage: "url('/leader2.png')",
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    zIndex: 1
                  }}
                />
              </div>

              {/* Text */}
              <div className="flex-1 text-center md:text-left">
                <p className="font-normal text-[16px] sm:text-[18px] md:text-[20px] leading-[1.6] md:leading-[29px] text-[#1A1A1A]">
                  <span className="font-bold">Seasoned technology leader</span>, she is recognized for driving cutting-edge innovations, operational excellence, and breakthrough ideas that transform businesses. With a forward-looking AI-first mindset, she has pioneered intelligent solutions that accelerate digital transformation and unlock new business models. Her expertise has taken multiple product lines to global markets, securing large-scale client acquisitions and expanding enterprise footprints worldwide.
                  <br /><br />
                  Several of her visionary initiatives have reached the heights of recognition in Gartner Magic Quadrants, underscoring her ability to turn technical concepts into industry-leading products. Beyond technology, she is deeply business-oriented, having engaged in CXO-level decision-making and client-facing strategy, seamlessly bridging innovation with enterprise growth.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Board Member Section - Distinct */}
      <section className="w-full py-16 md:py-20 lg:py-24">
        <div className="w-full px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-20">
          <div className="w-full max-w-6xl mx-auto">
            <h2
              className="text-center font-medium text-[28px] sm:text-[34px] leading-[40px] sm:leading-[49px] text-[#1A1A1A] mb-12 md:mb-16"
              style={{
                textShadow: '0px 4px 4px rgba(0, 0, 0, 0.02)',
                backdropFilter: 'blur(2px)'
              }}
            >
              Board Member
            </h2>

            <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12 lg:gap-20">
              {/* Image Container */}
              <div className="relative w-full max-w-[380px] aspect-[380/390] flex-shrink-0 mx-auto md:mx-0">
                {/* Gradient Frame */}
                <div
                  className="absolute inset-0 rounded-[5px] translate-x-[-6px] translate-y-[-6px]"
                  style={{
                    background: 'linear-gradient(139.65deg, #F05736 0%, #FBB12F 95.17%)',
                    zIndex: 0
                  }}
                />
                {/* Image */}
                <div
                  className="absolute inset-0 rounded-[5px] overflow-hidden bg-gray-200"
                  style={{
                    backgroundImage: "url('/leader2.png')",
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    zIndex: 1
                  }}
                />
              </div>

              {/* Text */}
              <div className="flex-1 text-center md:text-left text-[#1A1A1A]">
                <p className="font-normal text-[16px] sm:text-[18px] md:text-[20px] leading-[1.6] md:leading-[29px]">
                  A seasoned business and technology leader with close to three decades of experience shaping enterprise strategy and driving large-scale transformation. As a Board Member at Elowen, provides strategic direction, governance oversight, and long-term vision to support sustainable growth and market differentiation.
                  <br /><br />
                  Brings deep expertise across digital transformation, data-driven platforms, cloud, and enterprise modernization, with a strong ability to connect strategy to execution. An alumnus of IIT Mumbai, known for clarity of thought and decisive leadership, works closely with the leadership team to guide critical decisions and scale high-impact initiatives.
                  <br /><br />
                  A trusted advisor and mentor, deeply committed to building resilient organizations, developing future leaders, and creating enduring value.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />

      <style jsx>{`
        .custom-cursor-container { cursor: none; }
        .custom-cursor-container * { cursor: none !important; }
        .custom-cursor {
          position: fixed;
          pointer-events: none;
          z-index: 9999;
          transform: translate(-50%, -50%);
          transition: transform 0.05s ease-out;
        }
        .cursor-dot {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: rgba(240, 87, 54, 1);
          border: 2px solid rgba(255, 255, 255, 1);
          box-shadow: 0 2px 10px rgba(240, 87, 54, 0.5);
        }
      `}</style>
      <ContactModal
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
      />
    </div>
  );
};

export default AboutUsPage;
